import { Resources } from 'constants/resources';

import { AxiosResponse, AxiosError } from 'axios';
import { axios } from 'config/axios';
import qs from 'qs';
import { ExpenseReport } from 'types/embedded/expenseReport';

export type ExpenseReportParams = {
  dateFrom: number;
  dateTo: number;
  currency: string;
  referral?: number[];
  expenseTypes?: string[];
  expenseArticles?: string[];
  expenseSubarticles?: string[];
  timezone: string;
};

export const getExpenseReport = async (filter: ExpenseReportParams): Promise<ExpenseReport> => {
  const params = qs.stringify(
    {
      ...filter,
    },
    { arrayFormat: 'indices', encode: true },
  );
  return axios
    .get(`${Resources.ExpenseReport}?${params}`)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};
